import * as React from 'react';
import PhoneNumberInput, { State } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { TappInput, TappInputProps } from './TappInput';

type PhoneInputProps = Omit<TappInputProps, 'value' | 'onChange'> & { value?: any; onChange: (value: any) => any };

const PhoneInput = React.forwardRef<React.Component<PhoneInputProps, State<PhoneInputProps>, any>, PhoneInputProps>(
  ({ className, ...props }, ref) => {
    return (
      <PhoneNumberInput
        ref={ref}
        defaultCountry="US"
        inputComponent={TappInput}
        addInternationalOption={false}
        placeholder="Enter phone number"
        {...props}
      />
    );
  }
);
PhoneInput.displayName = 'Input';

export { PhoneInput };
